export default {
    text_1: "PREMIUM",
    text_2: "ADMIN",
    text_3: "NASTAVENIA",
    text_4: "Nová cenová ponuka",
    text_5: "Nápady na zlepšenie?",
    text_6: "Verzia ",
    text_7: "Firma: ",

    nastenka: "Nástenka",
    cenovePonuky: "Cenové ponuky",
    mojiKlienti: "Moji klienti",
    balicky: "Balíčky",
    novaCenovaPonuka: "Nová cenová ponuka",
    nastaveniaUctu: "Nastavenia účtu",
    firmaAKontakty: "Firma a kontakty",
    notifikacie: "Notifikácie",
    integracie: "Integrácie",
    vlastneFarbyPonuky: "Vlastné farby ponuky",
    recenzie: "Recenzie",
    mojiPouzivatelia: "Moji používatelia",
    mojeFirmy: "Moje firmy",
    polozkyACeny: "Položky a ceny",
    statistiky: "Štatistiky",
    blog: "Blog",
    pouzivatelia: "Používatelia",
    firmy: "Firmy",
    historiaBalickov: "História balíčkov",
    impersonating: "Klientské prihlásenie",
    subscriptions: "Predplatné",
    alerts: "Upozornenia",
    faktury: "Faktúry",
}